export default "__VITE_ASSET__BhLnHwdv__"